<i18n lang='yml' src='../i18n/HistoryTab.yml'></i18n>
<template>
  <div class="tab-content">
    <div class="tab-pane" :id="`history-${item.id}`">
      <history-table :locale="locale" :itemData="tableData(item)" name='logbook' :columnNumber="columnNumber" :column_info="columnData()"/>
    </div>
  </div>
</template>
<script>
import Table from '../../shared/table/components/Table.vue'
export default {
  props: ['item', 'locale', 'trainer_details'],
  components: {
    'history-table': Table
  },  
  data() {
    return {
      versions: [],
      columnNumber: 0,
    }
  },
  mounted() {
    if(this.item.status && this.item.status.versions && Object.keys(this.item.status).length > 0) {
      this.versions = this.item.status.versions.reverse()
    }
  },
  methods: {
    tableData(item) {
      return item.status && item.status.versions && item.status.versions.length > 0 ? item.status.versions.map((statusChange) => {
        return {
          created_at: statusChange.created_at, 
          full_name: statusChange.user_identity ? `${statusChange.user_identity.first_name} ${statusChange.user_identity.last_name}` : statusChange.whodunnit_name,
          status: statusChange.status ? statusChange.status[this.locale] : '',
          trainer_details: this.formatTrainerDetails(statusChange)
        }
      }) : []
    },
    formatTrainerDetails(statusChange) {
      if (statusChange.trainer_details && this.checkTrainerDetails(statusChange)) {
        `${statusChange.trainer_details.name} - ${statusChange.trainer_details.sto_id} - ${statusChange.trainer_details.email}`
      }
    },
    columnData() {
      let columns = [
        {name: this.$i18n.t('time'), key: 'created_at', formatType: 'date'},
        {name: this.$i18n.t('user'), key: 'full_name'},
        {name: this.$i18n.t('status_applied'), key: 'status'}
      ]
      if(this.trainer_details) {
        columns.push({name: this.$i18n.t('trainer_details'), key: 'trainer_details'})
      }
      this.columnNumber = columns.length
      return columns
    },
    //Check if trainer detail strings are empty when submitting new status.
    checkTrainerDetails(statusChange){
      if (!Object.keys(statusChange.trainer_details).length) {
        return false;
      }
      let has_details = true;
      
      Object.entries(statusChange.trainer_details).forEach(([key, value]) => {
        if (value == ''){
          has_details = false;
        }
      });
      return has_details;
    },
  }

}
</script>
